import { AppConfigInput } from './domain/value-objects/AppConfig.js'

export function defineConfig(config: AppConfigInput) {
  return config
}
